import React from "react";
import "../../styles/Sidebar.css";

function Sidebar({ onSelect, selected, collapsed, onToggle, style }) {
  const sections = [
    {
      title: "General",
      items: [
        {
          id: "dashboard",
          label: "Dashboard",
          icon: (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="12"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.6"
                fill="none"
              />
              <path
                d="M8 20h8"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
            </svg>
          ),
        },
        // {
        //   id: "balances",
        //   label: "Main Accounts",
        //   icon: (
        //       <svg
        //           width="20"
        //           height="20"
        //           viewBox="0 0 24 24"
        //           fill="none"
        //           xmlns="http://www.w3.org/2000/svg"
        //           aria-hidden
        //       >
        //         <path
        //             d="M12 2v4"
        //             stroke="currentColor"
        //             strokeWidth="1.6"
        //             strokeLinecap="round"
        //         />
        //         <path
        //             d="M6 8h12v8a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V8z"
        //             stroke="currentColor"
        //             strokeWidth="1.4"
        //             fill="none"
        //         />
        //         <path
        //             d="M8 12h8"
        //             stroke="currentColor"
        //             strokeWidth="1.4"
        //             strokeLinecap="round"
        //         />
        //       </svg>
        //   ),
        // },
      ],
    },
    {
      title: "Inventory",
        items: [
          {
            id: "products",
            label: "Products",
            icon: (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                >
                  <path
                      d="M12 2v4"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                  />
                  <path
                      d="M6 8h12v8a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V8z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      fill="none"
                  />
                  <path
                      d="M8 12h8"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                  />
                </svg>
            ),
          },
          {
            id: "stockValue",
            label: "Stock Value",
            icon: (
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden
                >
                  <path
                      d="M12 2v4"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                  />
                  <path
                      d="M6 8h12v8a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4V8z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      fill="none"
                  />
                  <path
                      d="M8 12h8"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                  />
                </svg>
            ),
          }
        ]
    },
    {
      title: "Sales",
      items: [
        {
          id: "customers",
          label: "Customers",
          icon: (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <circle
                cx="9"
                cy="8"
                r="2.2"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
              <path
                d="M3.5 20c1.8-3 4.6-4 7.5-4s5.7 1 7.5 4"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
                fill="none"
              />
              <circle
                cx="17"
                cy="8"
                r="1.6"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
            </svg>
          ),
        },
        {
          id: "salesByDate",
          label: "Sales By Date",
          icon: (
              <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden
              >
                <rect
                    x="3"
                    y="4"
                    width="18"
                    height="18"
                    rx="2"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    fill="none"
                />
                <path d="M16 2v4" stroke="currentColor" strokeWidth="1.4" />
                <path d="M8 2v4" stroke="currentColor" strokeWidth="1.4" />
              </svg>
          ),
        },
        {
          id: "salesByCategory",
          label: "Sales By Category",
          icon: (
              <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden
              >
                <path
                    d="M4 7h4l2 3 3-6 3 6 2-3h2"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
              </svg>
          ),
        },
        {
          id: "topCategories",
          label: "Top Categories",
          icon: (
              <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden
              >
                <path
                    d="M12 17.3l4.9 2.6-1.3-5.5L19 11l-5.6-.5L12 5l-1.4 5.5L5 11l3.4 3.4-1.3 5.5L12 17.3z"
                    stroke="currentColor"
                    strokeWidth="1.2"
                    fill="none"
                />
              </svg>
          ),
        },
        {
          id: "topProducts",
          label: "Top Products",
          icon: (
              <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden
              >
                <path
                    d="M6 6h15l-1.5 9a2 2 0 0 1-2 1.6H9a2 2 0 0 1-2-1.6L5 3H3"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <circle cx="10" cy="20" r="1" fill="currentColor" />
                <circle cx="17" cy="20" r="1" fill="currentColor" />
              </svg>
          ),
        },
      ],
    },
    {
      title: "Purchases",
      items: [
        {
          id: "suppliers",
          label: "Suppliers",
          icon: (
              <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden
              >
                <path
                    d="M3 9l9-5 9 5v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9z"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    fill="none"
                />
                <path
                    d="M7 13h10"
                    stroke="currentColor"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                />
              </svg>
          ),
        },
        {
          id: "purchaseByDate",
          label: "Purchase By Date",
          icon: (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <rect
                x="3"
                y="4"
                width="18"
                height="16"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
              <path d="M8 2v4" stroke="currentColor" strokeWidth="1.4" />
              <path d="M16 2v4" stroke="currentColor" strokeWidth="1.4" />
              <path
                d="M7 12h6"
                stroke="currentColor"
                strokeWidth="1.4"
                strokeLinecap="round"
              />
            </svg>
          ),
        },
      ],
    },
    {
      title: "Expenses",
      items: [
        {
          id: "expenseByCategory",
          label: "Expenses By Category",
          icon: (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden
            >
              <rect
                x="4"
                y="10"
                width="4"
                height="8"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
              <rect
                x="10"
                y="6"
                width="4"
                height="12"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
              <rect
                x="16"
                y="2"
                width="4"
                height="16"
                rx="1"
                stroke="currentColor"
                strokeWidth="1.4"
                fill="none"
              />
            </svg>
          ),
        },
      ],
    },
  ];

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`} style={style}>
      <div className="sidebar-logo">
        <button
          className="sidebar-logo-btn"
          aria-label="Go to main"
          onClick={(e) => {
            onSelect && onSelect("dashboard");
            e.currentTarget.blur();
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onSelect && onSelect("dashboard");
              e.currentTarget.blur();
            }
          }}
        >
          <img
            src="/images/BrainLogoSimple.png"
            alt="Weview"
            onError={(e) => {
              const container = e.currentTarget.parentElement;
              if (!container) return;
              container.querySelector("img")?.remove();
              const svg = document.createElementNS(
                "http://www.w3.org/2000/svg",
                "svg"
              );
              svg.setAttribute("width", "28");
              svg.setAttribute("height", "28");
              svg.setAttribute("viewBox", "0 0 64 64");
              svg.setAttribute("aria-hidden", "true");
              svg.innerHTML = `
                <defs>
                  <linearGradient id="weview-grad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#6fb4ff" />
                    <stop offset="1" stop-color="#5b8ef0" />
                  </linearGradient>
                </defs>
                <path d="M32 4C20 10 8 24 8 36c0 12 10 20 24 24 14-4 24-12 24-24 0-12-12-26-24-32z" fill="url(#weview-grad)"/>
                <path d="M32 12c-6 8-12 16-12 24 0 8 6 14 12 18" stroke="#ffffff" stroke-width="2" fill="none" stroke-linecap="round"/>
              `;
              container.insertBefore(svg, container.firstChild);
            }}
          />
          <span className="sidebar-logo-title">WeView</span>
        </button>
      </div>
      <nav>
        {sections.map((section, sIdx) => (
          <div className="sidebar-section" key={sIdx}>
            {section.title && (
              <div className="sidebar-section-title">{section.title}</div>
            )}

            <div className={`sidebar-section-items open`}>
              {section.items.map((tab) => (
                <div
                  key={tab.id}
                  className={`sidebar-item ${
                    selected === tab.id ? "active" : ""
                  }`}
                  onClick={() => onSelect(tab.id)}
                >
                  <span
                    className="sidebar-item-icon"
                    data-label={tab.label}
                    onMouseEnter={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      document.documentElement.style.setProperty(
                        "--sidebar-tooltip-top",
                        `${rect.top + rect.height / 2}px`
                      );
                    }}
                    onMouseLeave={() => {
                      document.documentElement.style.setProperty(
                        "--sidebar-tooltip-top",
                        "-9999px"
                      );
                    }}
                    onFocus={(e) => {
                      const rect = e.currentTarget.getBoundingClientRect();
                      document.documentElement.style.setProperty(
                        "--sidebar-tooltip-top",
                        `${rect.top + rect.height / 2}px`
                      );
                    }}
                    onBlur={() => {
                      document.documentElement.style.setProperty(
                        "--sidebar-tooltip-top",
                        "-9999px"
                      );
                    }}
                  >
                    {tab.icon ?? ""}
                  </span>
                  <span className="sidebar-item-label">{tab.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </nav>
        <div className="sidebar-footer">
            <span className="sidebar-footer-text">&copy; 2025 All rights reserved.</span>
            <span className="sidebar-footer-text">Brain Solutions</span>
        </div>
    </div>
  );
}

export default Sidebar;
